import { Dispatch } from 'redux';
import React from 'react';
import { RequestClass } from 'acscp/api/requests';
import { RequestStateProps } from 'acscp/components/common/helpers/requestStateProps';
import { connectWithRequests } from 'acscp/store/helpers/connectWithRequests';
import { AcceptAccountLinkRequest } from 'acscp/api/requests/acceptAccountLink';
import { AppState } from 'acscp/store';
import { RouteComponentProps } from 'react-router';
import { FetchRequest } from 'acscp/actions';
import { userIsLoggedIn } from 'acscp/store/helpers/authHelper';
import { createAccountAndRedirectTo, home, loginAndRedirectTo } from '../routeHelper';

type AcceptAccountLinkStateProps = RequestStateProps & {
    isLoggedIn: boolean;
};

interface AcceptAccountLinkDispatchProps {
    acceptAccountLink: (token: string) => void;
}

export interface AcceptAccountLinkRouteParams {
    acceptAccountLinkToken: string;
}

type AcceptAccountLinkRouteProps = RouteComponentProps<AcceptAccountLinkRouteParams>;

type AcceptAccountLinkProps = AcceptAccountLinkStateProps & AcceptAccountLinkDispatchProps & AcceptAccountLinkRouteProps;

class AcceptAccountLinkPresentational extends React.Component<AcceptAccountLinkProps> {
    componentDidMount(): void {
        if (!this.props.isLoggedIn) {
            const goToCreateAccount = new URLSearchParams(this.props.location.search).has('newAccount');

            this.props.history.push(
                goToCreateAccount
                ? createAccountAndRedirectTo(this.props.location)
                : loginAndRedirectTo(this.props.location)
            );
        } else {
            const token = this.props.match.params.acceptAccountLinkToken;
            this.props.acceptAccountLink(token);
            this.props.history.push(home());
        }
    }

    render(): null {
        return null;
    }
}

function mapStateToProps(
    state: AppState, ownProps: {}, getRequestError: (request: RequestClass<any>) => RequestStateProps
): AcceptAccountLinkStateProps {
    return {
        ...getRequestError(AcceptAccountLinkRequest),
        isLoggedIn: userIsLoggedIn(state.auth)
    };
}

function mapDispatchToProps(dispatch: Dispatch): AcceptAccountLinkDispatchProps {
    return {
        acceptAccountLink: (token: string) => dispatch(new FetchRequest(new AcceptAccountLinkRequest(token)))
    };
}

export const AcceptAccountLink = connectWithRequests(mapStateToProps, mapDispatchToProps)(AcceptAccountLinkPresentational);
